export default __webpack_public_path__ + "media/project-management.a7d8acf83dab107d53abcab76db9e04c.svg";